import './badge.scss';

export enum BadgeType {
	DEFAULT = 'badge-default',
	WARNING = 'badge-warning',
	SUCCESS = 'badge-success',
	INFO = 'badge-info',
	PRIMARY = 'badge-primary',
}

export interface IBadgeProps {
	type?: BadgeType;
    text: string,
}

export const Badge: React.FC<IBadgeProps> = ({ type = BadgeType.DEFAULT, text }) => (
	<span className={`badge ${type}`}>
		{ text }
	</span>
);
